/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

//env('../.env');

import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import axios from './backend/vue-axios'
import store from './store'

import router from './routes/router';

//import Maska from 'maska';

//Vue.use(Maska);

Vue.use(DashboardPlugin);
import ActionCableVue from 'actioncable-vue';

const WS_URL = process.env.VUE_APP_WS_URL+"?token="+localStorage.token || 'wss://neu.flatkalkulator.de/cable'+"?token="+localStorage.token

import { isMobile } from 'mobile-device-detect';
import ApiDataService from './backend/vue-axios/api/';

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.use(ApiDataService, { axios: axios } );

Vue.use(ActionCableVue, {
    debug: true,
    debugLevel: 'info',
    connectionUrl: WS_URL,
    connectImmediately: true,
    store
  });

  new Vue({
  el: '#app',
  render: h => h(App),
  router,
  axios,
  store
});



/*
const app = Vue.createApp({...})
// use as plugin
app.use(Maska);
// or as directive
// app.directive('maska', Maska.maska);
app.mount('#app');
*/